import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import VendorSelection from "../pages/vendor-selection/page";
import MonthlyAvailability from "../pages/monthly-availability/page";
import DailySchedule from "../pages/daily-schedule/page";
import Confirmation from "../pages/confirmation/page";
import Login from "../pages/login/page";
import RequireAuth from "../components/auth/RequireAuth";
import GuestOnly from "../components/auth/GuestOnly";
import BasicSetup from "@/pages/customer-setup/page";
import RequireCustomerInfo from "@/components/auth/RequireCustomerInfoGuard";
import RequireCustomerInfoGuard from "@/components/auth/RequireCustomerInfoGuard";
import RestoreCustomerInfoGuard from "@/components/auth/RestoreCustomerInfoGuard";
import Home from "@/pages/home/page";
import ReservationDetailPage from "@/pages/reservations/detail";
import ReservationsPage from "@/pages/reservations/page";
import ShopCalendar from "@/pages/shop-calendar/page";
import WeeklyMulityShopSelectorPage from "@/pages/multishop-selection/page";
const routes: RouteObject[] = [
  {
    element: <GuestOnly />,
    children: [
      {
        path: '/login',
        element: <Login />,
      },
    ],
  },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        // element: <RestoreCustomerInfoGuard />,
        children: [
          
          {
            // element: <RequireCustomerInfoGuard />,
            children: [
              {
                path: '/vendors',
                element: <VendorSelection />,
              },
              {
                path: '/monthly-availability',
                element: <MonthlyAvailability />,
              },
              {
                path: '/daily-schedule',
                element: <DailySchedule />,
              },
              {
                path: '/confirmation',
                element: <Confirmation />,
              },
              
            ],
          },
        ],
      },
      {

        children: [
          {
            path: '/reservations',
            element: <ReservationsPage />,
          },
          {
            path: '/reservations/:reservationCode',
            element: <ReservationDetailPage />,
          },
          {
            path: '/shop-calendar',
            element: <WeeklyMulityShopSelectorPage />,
          },
          {
            path: '/shop-calendar2',
            element: <ShopCalendar />,
          },
        ],
      }
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;